namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_posts, {
		
		Post: {
			whiteSpace: 'pre-line',
		},
		
		Posts: {
			// pointerEvents: 'none',
			gap: '1rem',
			flex: {
				direction: 'column'
			},
		},
		
	} )
	
}
